import React, { useState } from "react";

import { Modal, Input, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

import { useCaseViewContext } from '../../../context/CaseViewContext'

const CaseReviewRejectionModal = ({
    rejectReview,
    reviewModalVisible,
    hideReviewModal,
}) => {
    const { fetchCaseDetails } = useCaseViewContext()

    const [reviewNotes, setReviewNotes] = useState('')

    const handleRejectReview = async () => {
        try {
          await rejectReview(reviewNotes)
          fetchCaseDetails()
        } catch (e) {
          message.error(e.message);
        }
      }

    return (
        <Modal
            title={<><CloseCircleOutlined style={{ color: 'red', marginRight: '5px'}}/>Return Case To Provider</>}
            open={reviewModalVisible}
            onOk={handleRejectReview}
            okText="Return to Physician"
            okType="danger"
            okButtonProps={{
                disabled: reviewNotes.length === 0
            }}
            onCancel={hideReviewModal}
            >
            <Input.TextArea
                id="case-review-rejection-notes-textarea"
                value={reviewNotes}
                onChange={e => setReviewNotes(e.target.value)}
                placeholder="Reasoning as to why this case should be Rx'd..."
                rows={4}
            />
        </Modal>     
    )
}

export default CaseReviewRejectionModal;